export enum RouteEnum {
  HOME = 'home',
  PROGRAMS = 'programs',
  WEAPONS = 'weapons',
  STORAGE = 'storage',
  USERS = 'users',
  VIDEOS = 'videos',
  CONTACT = 'contact',
  CHANGELOG = 'changelog',
  CGU = 'cgu',
  MENTIONS_LEGALES = 'mentions',
  SITE_MAP = 'sitemap',
  A11Y = 'a11y',
  LIVENESS = 'liveness',
  DEVELOPER_SESSION = 'session',
  DEVELOPER_CONSOLE = 'console',
}

export class RouteEnumTools {
  static convertPathToRoute(path: string): RouteEnum {
    const extractedRoute = path.slice(1);
    if (Object.values(RouteEnum).includes(extractedRoute as RouteEnum)) {
      return extractedRoute as RouteEnum;
    } else {
      return RouteEnum.HOME;
    }
  }
}
